import DataGrid, { Column, Export } from 'devextreme-react/data-grid';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
// import { IColumnTable } from './TableDevReport';
import 'devextreme/dist/css/dx.light.css';
import { IColumnTable } from './Table';

const DataGridWraper = styled(DataGrid)<{ maxHeight?: number }>`
  max-height: ${props => props.maxHeight + 'vh !important'};
  .dx-datagrid-headers .dx-header-row {
    background-color: #ededed;
    color: black;
    font-weight: 500;
    > td {
      vertical-align: middle !important;
      text-align: center !important;
    }
  }
  .dx-row.dx-data-row.dx-column-lines.dx-state-hover td {
    background: #d8d8d8 !important;
  }

  .dx-datagrid-headers .dx-header-row {
    background-color: #ededed;
    color: black;
    font-weight: 500;
    text-transform: capitalize;
    > td {
      vertical-align: middle !important;
      text-align: center !important;
    }
  }
  .dx-row.dx-data-row.dx-column-lines.dx-state-hover td {
    background: #d8d8d8 !important;
  }
`;

interface SubDetailProps {
  data: Array<any>;
  columns: Array<IColumnTable>;
  gridHeight?: number;
  allowColumnResizing?: boolean;
  tileTable?: string;
}

/** bản table phụ theo từng dòng bên bản chính (cấu hình table chỉ là mức cơ bản nhất) */
export default function SubDetailTable(props: SubDetailProps) {
  const { t } = useTranslation();

  const dataTable = useMemo(() => {
    return props.data;
  }, [props.data]);

  const columnsTable = useMemo(() => {
    return props.columns;
  }, [props.columns]);

  return (
    <>
      <div className="master-detail-caption font-semibold">{`${props.tileTable || ''}`}</div>
      <DataGridWraper
        maxHeight={props.gridHeight && props.gridHeight}
        dataSource={dataTable}
        showBorders={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        noDataText={t('Table.NoData')}
        allowColumnResizing={props.allowColumnResizing ? props.allowColumnResizing : true}
      >
        {columnsTable.map((e: any, key: number) => {
          if (e.childHeader) {
            return (
              <Column key={key} caption={e.caption} dataField={e.dataField} visible={e.visible !== false}>
                {e.childHeader.map((e: any, key: number) => (
                  <Column
                    key={key}
                    type={e.type ? e.type : undefined}
                    dataField={e.dataField}
                    caption={e.caption}
                    cellRender={e.cellRender && e.cellRender}
                    width={e.width}
                    minWidth={e.minWidth}
                    visible={e.visible !== false}
                    allowHiding={e.allowHiding ? e.allowHiding : true}
                    showInColumnChooser={e.showInColumnChooser != undefined ? e.showInColumnChooser : true}
                    dataType={e.dataType ? e.dataType : undefined}
                    selectedFilterOperation={e.selectedFilterOperation ? e.selectedFilterOperation : undefined}
                    fixed={e.fixed !== undefined ? e.fixed : undefined}
                    fixedPosition={e.fixedPosition ? e.fixedPosition : 'left'}
                    format={e.format}
                    allowFiltering={e.allowFiltering}
                    headerFilter={e.headerFilter}
                    defaultSortOrder={e.defaultSortOrder && e.defaultSortOrder}
                    defaultFilterValue={e.defaultFilterValue ? e.defaultFilterValue : undefined}
                    allowSorting={e.allowSorting}
                    alignment={e.alignment ? e.alignment : 'left'}
                    editCellRender={e.allowEditing && e.editCellRender}
                    allowEditing={e.allowEditing ? true : false}
                    groupIndex={e.groupIndex == 0 ? e.groupIndex : undefined}
                  ></Column>
                ))}
              </Column>
            );
          }

          return (
            <Column
              key={key}
              type={e.type ? e.type : undefined}
              dataField={e.dataField}
              caption={e.caption}
              headerCellRender={e.headerRender ? e.headerRender : undefined}
              cellRender={e.cellRender && e.cellRender}
              cellTemplate={e.cellTemplate && e.cellTemplate}
              dataType={e.dataType ? e.dataType : undefined}
              selectedFilterOperation={e.selectedFilterOperation ? e.selectedFilterOperation : undefined}
              defaultFilterValue={e.defaultFilterValue ? e.defaultFilterValue : undefined}
              allowHeaderFiltering={e.allowHeaderFiltering ? e.allowHeaderFiltering : undefined}
              filterType={e.filterType ? e.filterType : undefined}
              width={e.width}
              minWidth={e.minWidth}
              visible={e.visible !== false}
              allowHiding={e.allowHiding ? e.allowHiding : true}
              showInColumnChooser={e.showInColumnChooser != undefined ? e.showInColumnChooser : true}
              fixed={e.fixed ? e.fixed : undefined}
              fixedPosition={e.fixedPosition ? e.fixedPosition : 'left'}
              format={e.format}
              allowFiltering={e.allowFiltering}
              headerFilter={e.headerFilter}
              defaultSortOrder={e.defaultSortOrder && e.defaultSortOrder}
              allowSorting={e.allowSorting}
              alignment={e.alignment ? e.alignment : 'left'}
              editCellRender={e.allowEditing && e.editCellRender}
              allowEditing={e.allowEditing ? true : false}
              groupIndex={e.groupIndex == 0 ? e.groupIndex : undefined}
            ></Column>
          );
        })}
      </DataGridWraper>
    </>
  );
}
